import { getNumberFormatter } from './get-number-formatter';

const CURRENCY_FORMAT_LOCALE = 'he-IL';

interface CurrencyFormatOptions {
  currency?: string | null;
  currencySymbol?: string | null;
}

function formatCurrency(
  balance: number | string,
  { currency, currencySymbol }: CurrencyFormatOptions = {},
  settings: {
    locale?: string;
    minimumFractionDigits: number;
    maximumFractionDigits: number;
  } = {
    locale: CURRENCY_FORMAT_LOCALE,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }
) {
  if (currency) {
    const isUzs = currency === 'UZS';

    const formatter = getNumberFormatter(CURRENCY_FORMAT_LOCALE, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: isUzs ? 0 : settings.minimumFractionDigits,
      maximumFractionDigits: isUzs ? 0 : settings.maximumFractionDigits,
    });

    const formattedBalance = formatter.format(
      typeof balance === 'string'
        ? (balance as Intl.StringNumericLiteral)
        : balance
    );
    const standardSymbol = formattedBalance.replace(/^.*[0-9]/, '').trim();
    return currencySymbol == null
      ? formattedBalance
      : formattedBalance.replace(standardSymbol, currencySymbol);
  }
}

function getCurrencySymbol(currencyCode: string) {
  return (
    getNumberFormatter(CURRENCY_FORMAT_LOCALE, {
      style: 'currency',
      currency: currencyCode,
    })
      .formatToParts(1)
      .find((part) => part.type === 'currency')?.value ?? currencyCode
  );
}

export { formatCurrency, getCurrencySymbol };
